var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appButtonContainer",class:[("appButtonContainer_" + _vm.type)]},[_c('button',{staticClass:"appButton",style:({ width: _vm.width }),on:{"click":_vm.handleClick}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }